import React from "react"
import Layout from "../components/Global/Layout/Layout"
import HeroSection from "../components/BlogPage/HeroSection/HeroSection"
import Tabs from "../components/BlogPage/Tabs/Tabs"
import { graphql } from "gatsby"
import SEO from "../components/Global/SEO/seo"
import { prefixStatamicAssetUrl } from "../utils/statamicAssets"

const blog = ({ data, pageContext }) => {
  const entries = (data && data.statamic && data.statamic.entries && data.statamic.entries.data) || []
  const posts = entries.map((node) => ({
    node: {
      id: node.id,
      title: node.title,
      slug: node.slug,
      publishedOn: node.published_on,
      externalLink: node.external_link,
      previewImage: node.preview_image
        ? {
            url: prefixStatamicAssetUrl(
              node.preview_image.permalink || node.preview_image.url
            ),
            title: node.preview_image.alt || node.title,
          }
        : null,
      category: (node.blog_categories || []).map((c) => ({
        slug: c.slug,
        name: c.title,
      })),
    },
  }))

  const categoryName =
    pageContext.category &&
    pageContext.category.charAt(0).toUpperCase() + pageContext.category.slice(1)

  return (
    <Layout>
      <SEO page="blog" title={categoryName ? `${categoryName} | Blog` : null} />
      <HeroSection />
      <Tabs
        posts={posts}
        showFeatured={false}
        showCategory={false}
        pageContext={pageContext}
      />
    </Layout>
  )
}

export default blog

export const query = graphql`
  query GetStagPosts($humanPageNumber: Int!, $limit: Int!, $category: String!) {
    statamic {
      entries(
        collection: "blog_posts"
        page: $humanPageNumber
        limit: $limit
        sort: "published_on desc"
        filter: { blog_categories: { contains: $category } }
      ) {
        data {
          id
          title
          slug
          ... on Statamic_Entry_BlogPosts_BlogPost {
            published_on(format: "d F Y")
            external_link
            preview_image {
              url
              permalink
              ... on Statamic_Asset_Assets {
                alt
                width
                height
              }
            }
            blog_categories {
              slug
              title
            }
          }
        }
        total
        current_page
        has_more_pages
      }
    }
  }
`
